import React from 'react';

const formatCurrency = (value) => {
  if (value == null || isNaN(value)) return '$0';
  return `$${Number(value).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
};

const RentToOwnGoldExecSummary = ({ investorResult, borrowerResult, params }) => {
  if (!investorResult || !borrowerResult || !params) {
    return <div className="text-center text-gray-500">No data available.</div>;
  }

  return (
    <div className="bg-green-50 p-6 rounded-lg text-sm text-gray-800 leading-relaxed space-y-4">
      <h3 className="text-lg font-bold text-green-900">Executive Summary</h3>
      <p>
        This <strong>Rent-to-Own + Gold Reinvestment</strong> model simulates a hybrid investment scenario over a {investorResult.termYears}-year period,
        where the investor purchases a property worth <strong>{formatCurrency(params.propertyValue)}</strong> and offers a rent-to-own path to an entrepreneur.
        The investor receives full rental income, a portion of which goes toward equity buyout, while a defined percentage (
        <strong>{params.reinvestmentSplit}%</strong>) of the investor’s revenue (rent and buyout) is reinvested quarterly to compound over time.
      </p>

      <h4 className="font-semibold text-green-800">📈 Investor Highlights</h4>
      <ul className="list-disc list-inside space-y-1">
        <li>Total Rent Collected: <strong>{formatCurrency(investorResult.totalRentCollected)}</strong></li>
        <li>Net Cashflow (after expenses): <strong>{formatCurrency(investorResult.netCashflow)}</strong></li>
        <li>Reinvested Capital (Quarterly Compounded): <strong>{formatCurrency(investorResult.reinvestedCapital)}</strong></li>
        <li>Final Property Value: <strong>{formatCurrency(investorResult.finalValue)}</strong></li>
        <li>Total Exit Value: <strong>{formatCurrency(investorResult.exitValue)}</strong> (includes rent, equity, reinvestments minus sell cost)</li>
        <li>Total ROI: <strong>{investorResult.totalROI}%</strong></li>
        {/* <li>Annualized ROI: <strong>{investorResult.annualizedROI}%</strong></li> */}
        <li>Cash-on-Cash Return: <strong>{investorResult.cashOnCashReturn}%</strong></li>
      </ul>

      <h4 className="font-semibold text-purple-800">🏠 Entrepreneur Highlights</h4>
      <ul className="list-disc list-inside space-y-1">
        <li>Average Monthly Rent: <strong>{formatCurrency(borrowerResult.monthlyRentPayment)}</strong></li>
        <li>Total Rent Paid Over Time: <strong>{formatCurrency(borrowerResult.totalRentPaid)}</strong></li>
        <li>Equity Bought Out: <strong>{formatCurrency(borrowerResult.totalBuyout)}</strong></li>
        <li>Total Expenses (Tax, Insurance, Maintenance): <strong>{formatCurrency(borrowerResult.totalExpenses)}</strong></li>
        <li>Total Capital Invested: <strong>{formatCurrency(borrowerResult.totalPayment)}</strong></li>
        <li>Final Equity (Ownership Share): <strong>{formatCurrency(borrowerResult.equityBuilt)}</strong></li>
        <li>Exit Value (based on ownership): <strong>{formatCurrency(borrowerResult.exitValue)}</strong></li>
      </ul>

      <p>
        This model offers a unique structure where the <strong>investor benefits from immediate income and future compounding returns</strong>,
        while the <strong>entrepreneur builds real equity</strong> through consistent contributions. It is ideal for scenarios where flexible asset control,
        long-term reinvestment, and aligned wealth-building are priorities. Both parties share in the upside of Gold growth without relying on speculative leverage.
      </p>
    </div>
  );
};


export default RentToOwnGoldExecSummary;
